<template lang="pug">
.belief(
  :style="{height: height}")
  b-header
  .container(
    ref="fullpage",
    v-fullpage="opts",
    )
    .page(
      :style="{height: height, overflowY: 'scroll', paddingBottom: '20px'}")
      .nav
        transition(name="left-in")
          .line(v-show="init")
        transition(name="right-in")
          .title(v-show="init") {{langs[lang].belief}}
      .talk
        //- img.avatar(src="../assets/long.png")
        p {{langs[lang].detail1}}
          br
          | {{langs[lang].detail2}}
      .timeline
        transition(
          appear,
          name="left-in"
          )
          img.line.pc(src="../assets/timeline.png")
        transition(
          appear,
          name="top-in"
          )
          .line.mobi
        transition-group.items(
            appear,
            @before-enter="beforeEnter",
            @enter="enter")
            .item(
              v-for="(value, index) in list",
              :data-index="index",
              key='index')
                template(v-if="value.type === 'time'")
                  .time
                    .mask {{value.time}}
                  .descd
                template(v-else)
                  .avatar(
                    @click="openLink(value.link)")
                    .mask
                    img(:src="value.avatar")
                    .name {{value.name}}
                    .title {{value.title}}
                  .desc
</template>

<script>
import _ from 'lodash'
import footer from './footer'
import header from './header'
import fanpage from '../mixin/fanpage.js'
const Belief = {
  props: [],
  mixins: [fanpage],
  data () {
    return {
      list: [],
      random: {},
      langs: {
        en: {
          belief: 'OUR BELIEF',
          detail1: 'We hope all the entrepreneurs backed by BAI ',
          detail2: 'grow to role models for youth in the future',
          auther: 'Annabelle Long'
        },
        zh: {
          belief: '我们的理念',
          detail1: '我们希望BAI支持的每一位创业者，',
          detail2: '都能成为未来青年的榜样',
          auther: '龙宇'
        }
      }
    }
  },
  filters: {
  },
  mounted () {
    window.$http.get(window.hostName + 'wp-json/wp/v2/belief?per_page=100').then(res => {
      this.list = res.data.map((item, index) => {
        return {
          title: item.title.rendered,
          avatar: item.avatar.guid || 'http://via.placeholder.com/80x80',
          link: item.link,
          time: item.timeline.slice(-4),
          name: item.author_name,
          top: index
        }
      }).filter((item) => {
        if (this.lang === 'zh') {
          return /[\u4e00-\u9fa5]/.test(item.title) || /[\u4e00-\u9fa5]/.test(item.content)
        } else {
          return !/[\u4e00-\u9fa5]/.test(item.title) && !/[\u4e00-\u9fa5]/.test(item.content)
        }
      }).slice(0, 8)
      this.list = _.sortBy(this.list, function (n) {
        return n.time
      })
      let start = 0
      let newList = []
      this.list.forEach((item, index) => {
        if (item.time > start) {
          newList.push({
            type: 'time',
            time: item.time
          })
          start = item.time
        }
        newList.push(item)
      })
      this.list = newList
    })
  },
  components: {
    bFooter: footer,
    bHeader: header
  },
  computed: {
    lang () {
      return localStorage.lang
    },
    isMobi () {
      return window.isMobi
    }
  },
  methods: {
    beforeEnter: function (el) {
      window.Velocity.hook(el, 'translateY', '-20px')
      window.Velocity.hook(el, 'opacity', 0)
    },
    enter: function (el, done) {
      var delay = el.dataset.index * 50
      window.Velocity(
        el,
        {
          opacity: 1,
          translateY: 0
        },
        {
          duration: 500,
          delay,
          complete: done
        }
      )
    },
    openLink (link) {
      window.open(link)
    }
  }
}
export default Belief
</script>

<style scoped lang="stylus">
@import '../common.styl'
@media (min-width: 720px) {
  .talk{
    border-radius: 20px;
    border: 2px solid #02284f;
    width: 600px;
    margin: 50px auto 150px;
    position: relative;
    .avatar{
      position: absolute;
      height: 75px;
      width: 75px;
      border-radius: 75px;
      top: -37.5px;
      left: -37.5px;
    }
    .desc{
        height: 100px;
    }
    p{
      font-weight: bold;
      font-size: 18px;
      line-height: 2;
      color: #002b69;
      text-align: center;
      margin-top: 20px;
      &:before{
        content: "“"
      }
      &:after{
        content: "”"
      }
    }
    span{
      font-weight: bold;
      font-size: 18px;
      position: absolute;
      right: 0;
    }
  }
  .timeline{
    width: 1446px;
    height: 300px;
    margin: 80px auto 0;
    position: relative;
    .line{
      width: 100%;
      position: absolute;
      top: 150px;
    }
    .items{
      display: flex;
      justify-content: space-around;
      position: absolute;
      top: 130px;
      width: 100%;
      .item{
        position: relative;
        width: 45px;
        .time{
          position: absolute;
          z-index: 9;
          font-size: 12px;
          width: 64px;
          height: 64px;
          top: 120px;
          text-align: center;
          line-height: 64px;
          background-color: #02284f;
          color: #fff;
          box-shadow: 0 0 0 5px rgba(2, 40, 79, .5);/*no*/
          border-radius: 100%
        }
        .avatar{
          cursor: pointer;
          position: absolute;
          top: -200px;
          left: -50px;
          width: 180px;
          height: 180px;
          overflow: hidden;
          border-radius: 50%;
          transform: scale(.5);
          transition: all .2s;
          z-index: 2;
          img{
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
          .mask{
            width: 100%;
            height: 100%;
            position: absolute;
            border-radius: 50%;
            top: 0;
            left: 0;
            background-color: rgba(0,43,105,0.8);
            display: none;
          }
          .name{
            position: absolute;
            top: 30px;
            text-align: center;
            width: 100%;
            font-size: 14px;
            color: rgba(255, 255, 255, .5);
            display: none;
          }
          .title{
            width: 100%;
            position: absolute;
            padding: 0 10px;
            top: 60px;
            text-align: center;
            font-weight: bold;
            font-size: 18px;
            color: #fff;
            display: none;
          }
          &:hover{
            transform: scale(1) !important;
            .mask, .name, .title{
              display: block;
            }
          }
        }
        .descd{
          width: 40px;
          border-left: 1px solid #000;/*no*/
          height: 120px;
          position: absolute;
          top: 30px;
          left: 32px;
          font-size: 14px;
          font-weight: bold;
          &:after{
            content: '';
            background-color: #e50027;
            border-radius: 100%;
            width: 10px;
            height: 10px;
            position: absolute;
            top: -5px;
            left: -6px;
          }
        }
        .desc{
          width: 40px;
          border-left: 1px solid #000;/*no*/
          height: 120px;
          position: absolute;
          top: -90px;
          left: 40px;
          font-size: 14px;
          font-weight: bold;
          &:after{
            content: '';
            background-color: #e50027;
            border-radius: 100%;
            width: 10px;
            height: 10px;
            position: absolute;
            bottom: -5px;
            left: -6px;
          }
        }
      }
    }
  }
}
@media (max-width: 720px) {
  .talk{
    border-radius: 20px;
    border: 4px solid #02284f;
    width: 1600px;
    margin: 150px auto 550px;
    position: relative;
    .avatar{
      position: absolute;
      height: 240px;
      width: 240px;
      border-radius: 240px;
      top: -37.5px;
      left: -37.5px;
      display: none;
    }
    p{
      font-weight: bold;
      font-size: 12px;/*no*/
      line-height: 2;
      color: #002b69;
      text-align: center;
      margin-top: 50px;
      &:before{
        content: "“"
      }
      &:after{
        content: "”"
      }
    }
    span{
      font-weight: bold;
      font-size: 18px;
      position: absolute;
      right: 0;
    }
  }
  .timeline{
    width: 1200px;
    margin: 80px auto 0;
    position: relative;
    .line{
      position: absolute;
      height: 105%;
      width: 20px;
      left: 45%;
      top: -10%;
      background-color: #b3b3b3;
      &:before{
        content:"";
        display: block;
        width: 80px;
        height: 80px;
        background-color: #e50027;
        border-radius: 50%;
        position: absolute;
        top: -30px;
        left: -30px;
      }
    }
    .items{
      justify-content: space-around;
      .item{
        position: relative;
        width: 100%;
        height: 400px;
        .time{
          position: absolute;
          z-index: 9;
          font-size: 12px;
          width: 240px;
          height: 240px;
          top: -120px;
          text-align: center;
          line-height: 240px;
          background-color: #02284f;
          color: #fff;
          box-shadow: 0 0 0 5px rgba(2, 40, 79, .5);/*no*/
          border-radius: 100%
        }
        .avatar{
          cursor: pointer;
          position: absolute;
          top: -120px;
          right: 32px;
          width: 240px;
          height: 240px;
          border-radius: 50%;
          z-index: 2;
          img{
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
          .mask{
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background-color: rgba(0,43,105,0.8);
            display: none;
          }
          .name{
            position: absolute;
            top: 90px;
            text-align: center;
            width: 100%;
            font-size: 14px;/*no*/
            color: rgba(255, 255, 255, .5);
            color: #fff;
            display: none;
          }
          .title{
            position: absolute;
            top: 80px;
            left: -1020px;
            width: 600px;
            line-height: 1.5;
            text-align: left;
            font-size: 12px;/*no*/
            font-weight: bold;
            color: #000;
          }
          &:hover{
            transform: scale(1);
            .mask, .name, .title{
              display: block;
            }
          }
        }
        .descd{
          width: 520px;
          border-bottom: 1px solid #000;/*no*/
          height: 1px;
          position: absolute;
          top: 0px;
          left: 32px;
          font-size: 14px;
          font-weight: bold;
          &:after{
            content: '';
            background-color: #e50027;
            border-radius: 100%;
            width: 40px;
            height: 40px;
            position: absolute;
            top: -20px;
            right: -20px;
          }
        }
        .desc{
          width: 520px;
          height: 1px;
          border-bottom: 1px solid #000;/*no*/
          position: absolute;
          top: 0;
          right: 120px;
          font-size: 12px;/*no*/
          &:after{
            content: '';
            background-color: #e50027;
            border-radius: 100%;
            width: 40px;
            height: 40px;
            position: absolute;
            top: -20px;
            left: -30px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// belief.vue?4db602e8